<script setup lang="ts">
import { useFooterNav } from '@/widgets/footer/composables/useFooterNav';
import { SPECIAL_CATEGORIES_SLUGS_EN } from '@/shared/constants/categories';
const { itemsList } = useFooterNav();
</script>

<template>
  <div class="footer-nav">
    <div v-for="column in itemsList" :key="column.id" class="footer-nav__item">
      <div class="footer-nav__title">
        {{ column.text }}
      </div>
      <ul class="footer-nav__list">
        <li
          v-for="link in column.links"
          :key="link.id"
          v-show="!SPECIAL_CATEGORIES_SLUGS_EN.includes(String(link.slug_en))"
          class="footer-nav__list-item"
        >
          <nuxt-link class="footer-nav__link" :to="link.url" :aria-label="link.text">
            {{ link.text }}
          </nuxt-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="less">
.footer-nav {
  display: flex;
  justify-content: space-between;
  gap: 140px;

  @media @1366 {
    gap: 90px;
  }

  &__item {
    .flex-column(@size-x6);
  }

  &__title {
    font-size: @size-x5;
    line-height: 100%;
    font-weight: 600;
    color: @color-cod-gray;
  }

  &__list {
    .flex-column(@size-x4);
  }

  &__link {
    .color-change-hover();

    font-size: @size-x4;
    line-height: 10%;
    font-weight: 400;
    color: @color-oxford-blue;
    white-space: nowrap;
  }
}
</style>
